import api from './apiClient';
import { ClinicSummary, VeterinarianWithClinic } from '../types';

export const clinicService = {
  searchAvailableClinics: async (params: {
    name?: string;
    region?: string;
    comuna?: string;
  }): Promise<ClinicSummary[]> => {
    const response = await api.get('/clinics/available/search', { params });
    return response.data;
  },

  getUserClinics: async (userId: number): Promise<ClinicSummary[]> => {
    const response = await api.get(`/clinics/user/${userId}`);
    return response.data;
  },

  getClinicPetRequests: async (clinicId: number, status?: string): Promise<any[]> => {
    const response = await api.get(`/clinics/${clinicId}/pet-requests`, {
      params: status ? { status } : {},
    });
    return response.data;
  },

  acceptPetRequest: async (clinicId: number, requestId: number): Promise<any> => {
    const response = await api.put(`/clinics/${clinicId}/pet-requests/${requestId}/accept`);
    return response.data;
  },

  rejectPetRequest: async (clinicId: number, requestId: number, reason?: string): Promise<any> => {
    const response = await api.put(`/clinics/${clinicId}/pet-requests/${requestId}/reject`, {
      reason,
    });
    return response.data;
  },

  cancelPetRequest: async (clinicId: number, requestId: number, reason?: string): Promise<any> => {
    const response = await api.put(`/clinics/${clinicId}/pet-requests/${requestId}/cancel`, {
      reason,
    });
    return response.data;
  },

  getRegions: async (): Promise<Array<{ id: number; name: string; code?: string }>> => {
    const response = await api.get('/clinics/regions');
    return response.data;
  },

  getComunas: async (regionId?: number): Promise<Array<{ id: number; name: string; region_id: number }>> => {
    const response = await api.get('/clinics/comunas', {
      params: regionId ? { region_id: regionId } : {},
    });
    return response.data;
  },
};

export const veterinarianService = {
  getVeterinarianByUserId: async (userId: number): Promise<VeterinarianWithClinic[]> => {
    const response = await api.get(`/veterinarians/user/${userId}`);
    return response.data;
  },
};

